import { useGetReport } from './useGetReport'

export const missionSpecialist = {
  getReport: useGetReport,
}
